import { SidebarAdditionalPackagePayment } from "../shared";
import { SidebarPackageGbPackageOffer } from "./SidebarPackageGbPackageOffer";

interface ISidebarPackageGbProps {
  userFunds: number | undefined;
  hasNoFunds: boolean;
  anniversaryDate: string;
  productOfferPrice: number;
  productOfferGrantValue: string;
}

export function SidebarPackageGb({
  hasNoFunds,
  userFunds,
  anniversaryDate,
  productOfferPrice,
  productOfferGrantValue,
}: ISidebarPackageGbProps) {
  return (
    <div className="only-mobile:flex-col">
      <SidebarPackageGbPackageOffer
        anniversaryDate={anniversaryDate}
        productOfferGrantValue={productOfferGrantValue}
        productOfferPrice={productOfferPrice}
        testId="gb-package-offer-box"
      />
      <SidebarAdditionalPackagePayment
        hasNoFunds={hasNoFunds}
        productOfferPrice={productOfferPrice}
        testId="gb-package-payment-box"
        type="packageGb"
        userFunds={userFunds}
      />
    </div>
  );
}
